import { X, Keyboard } from 'lucide-react';
import { IDE_SHORTCUTS } from '@/hooks/useKeyboardShortcuts';

interface KeyboardShortcutsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function KeyboardShortcutsDialog({ isOpen, onClose }: KeyboardShortcutsDialogProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50" onClick={onClose}>
      <div
        className="bg-[#252526] border border-[#555] rounded-lg w-full max-w-lg shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 border-b border-[#333]">
          <div className="flex items-center gap-2">
            <Keyboard className="w-4 h-4 text-[#4fc1ff]" />
            <h2 className="text-sm font-semibold text-white">Keyboard Shortcuts</h2>
          </div>
          <button
            onClick={onClose}
            className="text-[#858585] hover:text-white transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 max-h-[60vh] overflow-y-auto space-y-5">
          {IDE_SHORTCUTS.map((group) => (
            <div key={group.category}>
              <h3 className="text-[10px] font-semibold uppercase tracking-wider text-[#858585] mb-2">
                {group.category}
              </h3>
              <div className="space-y-1">
                {group.shortcuts.map((shortcut) => (
                  <div
                    key={shortcut.keys}
                    className="flex items-center justify-between px-3 py-1.5 rounded hover:bg-[#333] transition-colors"
                  >
                    <span className="text-xs text-[#cccccc]">{shortcut.label}</span>
                    <kbd className="px-2 py-0.5 bg-[#1e1e1e] border border-[#555] rounded text-[10px] font-mono text-[#cccccc]">
                      {shortcut.keys}
                    </kbd>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="px-5 py-3 border-t border-[#333] text-center">
          <p className="text-[10px] text-[#858585]">
            Press <kbd className="px-1 py-0.5 bg-[#1e1e1e] rounded border border-[#555] text-[10px] font-mono">Ctrl+Shift+P</kbd> to open the command palette
          </p>
        </div>
      </div>
    </div>
  );
}
